<template>
  <div id="app">
    <router-view />
    <DialogInsufficientToken ref="dialogInsufficientTokenRef" />
  </div>
</template>
<script setup>
import { ref, nextTick } from "vue";
import { bus } from "@/utils/mitt.js";
import DialogInsufficientToken from "@/components/user/DialogInsufficientToken.vue";
//监听打开token不足提示框
const dialogInsufficientTokenRef = ref(null);
bus.on("show-token-warning", () => {
  nextTick(() => {
    dialogInsufficientTokenRef.value.openDLG();
  });
});
</script>

<style lang="scss">
#app {
  font-size: 14px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #101010;
}
</style>
